@for (pos of placements; track pos) {
  <c-toaster class="p-3" position="fixed" [placement]="pos" />
}
